import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetExclusions = (periodId) => {
  const query = useApiQuery(
    ['courseAssignmentExclusions', periodId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/exclusions`),
    { enabled: !!periodId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    exclusions: query.data?.exclusions ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
